import { BASKET_CONTENTS_CHANGED } from 'nandos-middleware-api/service/basket/basket-service'

export default {

  props: {
    basketService: { type: Object, required: true },
    muted: Boolean,
  },

  data () {
    return {
      basket: null,
    }
  },

  computed: {
    iconClasses() {
      return {
        'nandos-pink--after': true,
      }
    },

    badgeConfig() {
      return {
        value: this.basket ? this.basket.totalItems : 0,
        overlap: true,
        right: true,
      }
    }
  },

  created() {
    this.getBasket();
    this.basketService.addObserver(this, BASKET_CONTENTS_CHANGED, this.getBasket);
  },

  beforeDestroy() {
    this.basketService.removeObserver(this, BASKET_CONTENTS_CHANGED);
  },

  methods: {
    getBasket() {
      this.basketService.getBasketSummary()
        .then(basket => {
          this.basket = basket
          if(basket.autoModified) {
            this.$toaster.show( this.$t('basketAutoModified') )
            basket.autoModified = false
          }
        })
    }
  }
}